import { Tooltip } from '@ds';
import { AssignButton } from '../AssignButton/AssignButton';

type MandatoryRoleAssignButtonProps = {
  isSelected: boolean;
  isLast: boolean;
  name: string;
  roleName: string;
  onAssign: () => void;
};

export const MandatoryRoleAssignButton = ({
  isSelected,
  isLast,
  name,
  roleName,
  onAssign,
}: MandatoryRoleAssignButtonProps) => {
  const detachDisabled = isSelected && isLast;

  return (
    <div className="flex w-full justify-end">
      <Tooltip
        isDisabled={!detachDisabled}
        content={`At least one ${roleName} must be assigned to the case. To detach ${name}, please first assign another ${roleName}.`}
        placement="top"
      >
        <div className="w-fit">
          <AssignButton isSelected={isSelected} isDisabled={detachDisabled} onAssign={onAssign} />
        </div>
      </Tooltip>
    </div>
  );
};
